export default {
  getCurrenStore: state => state.currentStore
}
